module.exports = __webpack_public_path__ + "img/hero.303649a0.jpg";